<template>
  <div>
    <v-alert v-if="!lesson.questions || !lesson.questions.length" type="warning"
      >Brak pytań. Dodaj pytanie za pomocą przycisku poniżej.</v-alert
    >
    <v-list v-if="lesson.questions && lesson.questions.length">
      <draggable
        v-model="lesson.questions"
        :group="{ name: 'questionsTree' }"
        class="draggable"
        handle=".text-lesson-edit-list-element__drag-questions"
        @start="drag = true"
        @end="drag = false"
      >
        <TextLessonEditListElement
          v-for="(question, index) in lesson.questions"
          :key="question.id"
          :question="question"
          :index="index"
          @update="updateQuestion"
          @remove="removeQuestion"
          @disableOutsideClick="disableOutsideClick"
          @enableOutsideClick="enableOutsideClick"
        />
      </draggable>
    </v-list>
    <v-divider class="my-2" />
    <v-btn color="success" block @click="showAddForm = true">Dodaj nowe pytanie</v-btn>
    <QuestionEditForm :show="showAddForm" title="Dodaj nowe pytanie" @close="addFormClose" @added="addNewQuestion" />
  </div>
</template>

<script>
import TextLessonEditListElement from '@/components/manage/courses/right-panel/lesson-edit/test-lesson/TextLessonEditListElement.vue';
import QuestionEditForm from '@/components/manage/courses/right-panel/lesson-edit/test-lesson/QuestionEditForm.vue';
import draggable from 'vuedraggable';

export default {
  components: {
    TextLessonEditListElement,
    QuestionEditForm,
    draggable
  },
  props: {
    lesson: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      showAddForm: false
    };
  },
  watch: {
    showAddForm(val) {
      if (val) {
        this.$emit('disableOutsideClick');
      } else {
        this.$emit('enableOutsideClick');
      }
    }
  },
  methods: {
    addFormClose() {
      this.showAddForm = false;
    },
    addNewQuestion(ev) {
      this.$emit('change', {
        type: this.lesson.type,
        value: [...this.lesson.questions, ev.question]
      });
    },
    updateQuestion(ev) {
      this.$emit('change', {
        type: this.lesson.type,
        value: this.lesson.questions.map(question => (question.id === ev.question.id ? ev.question : question))
      });
    },
    removeQuestion(ev) {
      this.$emit('change', {
        type: this.lesson.type,
        value: this.lesson.questions.filter(question => question.id !== ev.question.id)
      });
    },
    disableOutsideClick() {
      this.$emit('disableOutsideClick');
    },
    enableOutsideClick() {
      this.$emit('enableOutsideClick');
    }
  }
};
</script>
